export default {
    install(Vue) {
        Vue.prototype.$isAdministrator = function () {
            let auth = this.$getAuth();
            if (auth == null || auth == undefined || auth.AccessPermissionInternal == null || auth.AccessPermissionInternal == undefined ||
                auth.AccessPermissionInternal.UserProfileInternal == null || auth.AccessPermissionInternal.UserProfileInternal == undefined)
                return false;

            return auth.AccessPermissionInternal.UserProfileInternal.Code == '1';
        };
        Vue.prototype.$isAuthorize = function (controller, action) {
            let auth = this.$getAuth();
            if (auth == null || auth == undefined || auth.AccessPermissionInternal == null || auth.AccessPermissionInternal == undefined ||
                auth.AccessPermissionInternal.Controllers == null || auth.AccessPermissionInternal.Controllers == undefined || auth.AccessPermissionInternal.Controllers.length == 0)
                return false;

            let controllerFind = auth.AccessPermissionInternal.Controllers.find(item => {
                return item.Name == controller;
            });
            if (controllerFind == null || controllerFind == undefined || controllerFind.Actions == null || controllerFind.Actions == undefined || controllerFind.Actions.length == 0)
                return false;

            let actionFind = controllerFind.Actions.find(item => {
                return item.Name == this.$options.filters.upper(action);
            });
            if (actionFind == null || actionFind == undefined)
                return false;

            return true;
        };
    }
};


// WEBPACK FOOTER //
// ./src/utils/accessPermission.js